import { environment } from './../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CardapiosService {
  BASEURL: string;
  httpHeaders: HttpHeaders;

  constructor(private http: HttpClient) {
    this.BASEURL = environment.apiUrl;
 
    this.httpHeaders = new HttpHeaders({
      Authorization: localStorage.getItem('tokenMappe'),
    });
 }

  listaItemsCardapiosPorMarca(id: string): Observable<any> {
    return this.http.get(`${this.BASEURL}/items/brands/${id}`, {
      headers: this.httpHeaders,
    });
  }

  excluirItemCardapio(id: string): Observable<any> {
    return this.http.delete(`${this.BASEURL}/items/${id}`, {
      headers: this.httpHeaders,
    });
  }

  uploadImages(image: string): Observable<any> {
    return this.http.post(`${this.BASEURL}/images`, {
      image
    }, {
      headers: this.httpHeaders,
    });
  }

  salvarProduto(body: any): Observable<any> {
    return this.http.post(`${this.BASEURL}/items`, body, {
      headers: this.httpHeaders,
    });
  }

  obterDadosProduto(id: string): Observable<any> {
    return this.http.get(`${this.BASEURL}/items/${id}`, {
      headers: this.httpHeaders,
    });
  }

  editarProduto(id: string, body: any): Observable<any> {
    return this.http.put(`${this.BASEURL}/items/${id}`, body, {
      headers: this.httpHeaders,
    });
  }

  listaCategoriasProdutos(id: string): Observable<any> {
    return this.http.get(`${this.BASEURL}/categories/belonging/items/${id}`, {
      headers: this.httpHeaders,
    });
  }

  listaDestaque(id: string): Observable<any> {
    return this.http.get(`${this.BASEURL}/highlights/brand/${id}`, {
      headers: this.httpHeaders,
    });
  }

  obterMoedas(): Observable<any> {
    return this.http.get(`${this.BASEURL}/currencies`, {
      headers: this.httpHeaders,
    });
  }
}
